//CONSTANT
import { GET_APP_NAME_FOR_COLLECTION } from "../../app_constant";
//PACKAGES
import { auth, firestore } from "./config";
import _ from "lodash";

const collection = async () => {
  const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
  return firestore()
    .collection("apps")
    .doc(APP_NAME)
    .collection("users")
    .doc(auth().currentUser.uid);
};

async function SAVE_TEST_HISTORY(data) {
  try {
    console.log('SAVE_TEST_HISTORY called with data:', data);
    const collection_user = await collection();
    console.log('Collection user obtained:', collection_user);
    
    await collection_user.update({
      practice_test_history: data,
    });
    console.log('Test history updated successfully in database');
    return { status: true, error: "" };
  } catch (error) {
    console.error('Error in SAVE_TEST_HISTORY:', error);
    return { status: false, error: error.message };
  }
}

async function APPEND_TEST_HISTORY(newTestResult) {
  try {
    console.log('APPEND_TEST_HISTORY called with new test result:', newTestResult);
    const collection_user = await collection();
    
    // Use a transaction to ensure atomicity
    const result = await firestore().runTransaction(async (transaction) => {
      // Get current document
      const docRef = collection_user;
      const doc = await transaction.get(docRef);
      
      if (!doc.exists) {
        throw new Error('User document not found');
      }
      
      // Get current practice_test_history
      const currentHistory = doc.data().practice_test_history || [];
      console.log('Current history from database:', currentHistory);
      
      // Append new test result
      const updatedHistory = [...currentHistory, newTestResult];
      console.log('Updated history with new result:', updatedHistory);
      
      // Update the document
      transaction.update(docRef, {
        practice_test_history: updatedHistory
      });
      
      return { status: true, updatedHistory, error: "" };
    });
    
    console.log('Test history appended successfully to database');
    return result;
  } catch (error) {
    console.error('Error in APPEND_TEST_HISTORY:', error);
    return { status: false, error: error.message };
  }
}

async function DELETE_TEST_HISTORY(data) {
  try {
    const collection_user = await collection();
    await collection_user.update({
      practice_test_history: firestore.FieldValue.arrayRemove(data),
    });
    return { status: true, error: "" };
  } catch (error) {
    return { status: false, error: error.message };
  }
}

export { SAVE_TEST_HISTORY, APPEND_TEST_HISTORY, DELETE_TEST_HISTORY };
